module.exports = __webpack_public_path__ + "static/media/remove-dark.2a144589.svg";